import loginBg from "../../../assets/images/loginBg.png";
import { ForgetPassword } from "../../../components/forgetPassword/forgetPass.component";

export const ForgetPasswordPage = () => {
  return (
    <div className="site-content">
      <div className="container-fluid">
        <div className="row vh-100">
          <div className="m-auto">
            <div className="container p-0 auth-card">
              <div className="d-flex">
                <div className="flex-grow-1">
                  <img
                    src={loginBg}
                    alt="Forget Password page"
                    className="login-image"
                  />
                </div>
                <div className="flex-grow-1 d-flex flex-column w-100 p-5 p-xl-3 justify-content-center m-xl-2">
                  <div>
                    <h4 className="justify-content-center d-flex flex-row">
                      Reganalytics <span className="login-header">Auth</span>
                    </h4>
                  </div>
                  <div className="mb-1 text-center">
                    <p className="login-page-text mt-2">
                      Please provide the email address that
                    </p>
                    <p className="login-page-text">
                      you have used during registration
                    </p>
                  </div>
                  <ForgetPassword />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
